import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "minutesFields", "salaryFields"]

  connect() {
    this.refresh()
  }

  refresh(event) {
    this.toggleTargets.forEach((checkbox) => {
      const field = checkbox.dataset.targetField
      const container = this.element.querySelector(`[data-rosters--toggle-field-target="${field}"]`)
      if (!container) return
      container.classList.toggle("hidden", !checkbox.checked)
    })
  }
}
